import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [greeting, setGreeting] = useState("");

  const token = localStorage.getItem("token");
  let isLoggedIn = !!token;
  let user = { name: "", role: "" };

  // Dekodowanie tokena
  if (isLoggedIn && token) {
    try {
      const decoded = jwtDecode(token);
      user = {
        name: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "",
        role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "",
      };
    } catch (error) {
      console.error("Error decoding token:", error);
      isLoggedIn = false;
    }
  }

  // Ustawienie powitania na podstawie godziny
  useEffect(() => {
    const now = new Date();
    const hour = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const date = now.toLocaleDateString();

    let timeGreeting = "";
    if (hour < 12) {
      timeGreeting = "Good morning";
    } else if (hour < 18) {
      timeGreeting = "Good afternoon";
    } else {
      timeGreeting = "Good evening";
    }

    setGreeting(`${date}, ${hour}:${minutes} - ${timeGreeting}`);
  }, []);

  // Obsługa wylogowania
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div>
          <Link to="/" className="mr-4 font-bold">
            Home
          </Link>
          <span>
            {greeting}
            {isLoggedIn && `, ${user.name} (${user.role})`}
          </span>
        </div>
        <div className="flex items-center">
          <button
            className="mr-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="bg-gray-700 p-4 mt-2 rounded-lg shadow-lg">
          {isLoggedIn ? (
            <>
              <Link
                to="/events"
                className="block text-white hover:text-blue-400 mb-2"
                onClick={() => setMenuOpen(false)}
              >
                Events
              </Link>
              {user.role === "Admin" && (
                <>
                  <Link
                    to="/create-event"
                    className="block text-white hover:text-blue-400 mb-2"
                    onClick={() => setMenuOpen(false)}
                  >
                    Create Event
                  </Link>
                  <Link
                    to="/users"
                    className="block text-white hover:text-blue-400 mb-2"
                    onClick={() => setMenuOpen(false)}
                  >
                    Manage Users
                  </Link>
                  <Link
                    to="/all-users"
                    className="block text-white hover:text-blue-400 mb-2"
                    onClick={() => setMenuOpen(false)}
                  >
                    All Users
                  </Link>
                </>
              )}
              {(user.role === "Admin" || user.role === "Organizer") && (
                <Link
                  to="/my-events"
                  className="block text-white hover:text-blue-400 mb-2"
                  onClick={() => setMenuOpen(false)}
                >
                  My Events
                </Link>
              )}
              <Link
                to="/profile"
                className="block text-white hover:text-blue-400 mb-2"
                onClick={() => setMenuOpen(false)}
              >
                My Profile
              </Link>
              <button
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
                className="block text-white hover:text-red-500"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="block text-white hover:text-blue-400 mb-2"
                onClick={() => setMenuOpen(false)}
              >
                Login
              </Link>
              <Link
                to="/register"
                className="block text-white hover:text-blue-400 mb-2"
                onClick={() => setMenuOpen(false)}
              >
                Register
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
